// HIGH SPEED SHOP — Main JS Bundle
import { initCart } from './hs_cart';
import { initSearch } from './hs_search';
import { initRecentlyViewed } from './hs_recently_viewed';
import { initWishlist, loadWishlistState } from './hs_wishlist';

// Initialize on DOM ready
frappe.ready(function () {
	initCart();
	initSearch();
	initRecentlyViewed();
	initWishlist();
	window.hsLoadWishlistState = loadWishlistState;
	initMobileNav();
	initAccountDropdown();
	initMobileCategoryToggles();
});

function initMobileNav() {
	const toggle = document.getElementById('hs-menu-toggle');
	const nav = document.getElementById('hs-mobile-nav');
	if (!toggle || !nav) return;

	toggle.addEventListener('click', function () {
		const isOpen = nav.style.display !== 'none';
		nav.style.display = isOpen ? 'none' : 'block';
	});
}

function initAccountDropdown() {
	const btn = document.querySelector('.hs-account-toggle');
	const menu = document.getElementById('hs-account-menu');
	if (!btn || !menu) return;

	btn.addEventListener('click', function (e) {
		e.stopPropagation();
		const isOpen = menu.style.display !== 'none';
		menu.style.display = isOpen ? 'none' : 'block';
	});

	document.addEventListener('click', function (e) {
		if (!e.target.closest('.hs-account-dropdown')) {
			menu.style.display = 'none';
		}
	});
}

function initMobileCategoryToggles() {
	document.querySelectorAll('.hs-mobile-cat-toggle').forEach(function (toggle) {
		toggle.addEventListener('click', function () {
			const targetId = toggle.getAttribute('data-target');
			const subcats = document.getElementById(targetId);
			if (!subcats) return;
			const isOpen = subcats.style.display !== 'none';
			subcats.style.display = isOpen ? 'none' : 'block';
			toggle.classList.toggle('expanded', !isOpen);
		});
	});
}
